<template>
<v-container fluid fill-height>
    <v-row  style="padding:0;margin:0;height:100%"  >
      <v-col cols="12" style="padding:0" >
      <v-row align="end"  >
        <v-col cols="12" justify="end"  ref="list" style="background-color:#f1f1f1;height:calc(100vh - 110px); overflow-y:auto" >

          <v-row no-gutters v-for="msg in messaggi" :key="msg.id" :justify="msg.from=='guest' ? 'end':'start'" ma-0 mp-0>
          <v-col  
          pa-4 
          style="max-width:60%;" 
          outlined 
          :class=" msg.from=='guest' ? 'ma-3 speech-bubble':'ma-3 speech-bubble-left'"
          >

            <v-card-text>
            {{msg.txt}}
            <div style="text-align:right; font-size:0.7em">{{ convert_timestamp(msg.created_at.seconds)  }}</div>
            
            </v-card-text>
          </v-col>
          {{scrollBottom()}}
          </v-row>

          <div id="endlist"></div>
          </v-col >
          

</v-row>

      </v-col>
      
    </v-row>
    <v-row  style="height:42px; overflow:hidden; margin-top:-30px;background-color:#f1f1f1;">  
                <v-text-field
                dense
                background-color="white"
                v-model="testomsg"
                append-icon="mdi-send"
                solo
                rounded
                outlined
                clear-icon="mdi-close-circle"
                clearable
                type="text"
                @click:append="inviamsg"
                @click:append-outer="inviamsg"
                @click:prepend="changeIcon"
                @click:clear="clearMessage"
              ></v-text-field>
    </v-row>

</v-container>
</template>

<script>

/* eslint-disable no-unused-vars */
export default {
       data: () => ({
           righe:[],
           testomsg:null,

           password: 'Password',
      show: false,
      message: 'Hey!',
      marker: true,
      iconIndex: 0,
      icons: [
        'mdi-emoticon',
        'mdi-emoticon-cool',
        'mdi-emoticon-dead',
        'mdi-emoticon-excited',
        'mdi-emoticon-happy',
        'mdi-emoticon-neutral',
        'mdi-emoticon-sad',
        'mdi-emoticon-tongue',
      ],

       }),
       computed:{
          messaggi(){
            return this.$store.state.messages.data
          },
                icon () {
        return this.icons[this.iconIndex]
      },
       },
    methods: {
      convert_timestamp(unix_timestamp){
          var date = new Date(unix_timestamp * 1000);
          // Hours part from the timestamp
          var hours = date.getHours();
          // Minutes part from the timestamp
          var minutes = "0" + date.getMinutes();
          // Seconds part from the timestamp
          var seconds = "0" + date.getSeconds();

          // Will display time in 10:30:23 format
          var formattedTime = date.getDate()+"/"+(date.getMonth()+1)+"/"+date.getFullYear()+" "+ hours + ':' + minutes.substr(-2) + ':' + seconds.substr(-2);

          return formattedTime
      },
      inviamsg: function(){
        if(this.testomsg && this.testomsg.length>0){
          this.$store.dispatch("sendMessage",{from:'guest',to:'hotel',txt:this.testomsg})
          .then(data=>{
            this.testomsg=''
            const me = this;
            setTimeout(function(){ me.$refs.list.scrollTop =9999 }, 1000);
            
          })
          .catch(err=>{
            console.log('yy',err)
          })
        }
      },
    getec: function() {
      const payload = {
        Comando: "GetEstrattoContoPren",
        IdPrenotazione: this.$store.state.reservation.pmsid
      };
      console.log(payload);
      const me = this;
      this.$store.dispatch("APIRequestHR", payload).then(risp => {
        console.log(risp);
        if (risp.statusText == "OK") {
          me.righe = risp.data.RISULTATOJSON.EstrattoConto.Riga;
        }
      });
    },
         toggleMarker () {
        this.marker = !this.marker
      },
      sendMessage () {
        this.resetIcon()
        this.clearMessage()
      },
      clearMessage () {
        this.message = ''
      },
      resetIcon () {
        this.iconIndex = 0
      },
      changeIcon () {
        this.iconIndex === this.icons.length - 1
          ? this.iconIndex = 0
          : this.iconIndex++
      },
      scrollBottom () {
        
        const me = this;
            setTimeout(function(){ me.$refs.list.scrollTop =9999 }, 500);
      },
  },
  mounted() {
        const orderBy = ['created_at']
        this.$store.dispatch('messages/openDBChannel', {clauses: { orderBy }, pathVariables: {reservationId: this.$store.getters.reservationid}}).then(x=>{
        })
        this.scrollBottom() 
        
  },
}
</script>
<style scoped>
.speech-bubble {
	position: relative;
	background: #bbc9ad;
	border-radius: .4em;
}

.speech-bubble:after {
	content: '';
	position: absolute;
	right: 0;
	top: 50%;
	width: 0;
	height: 0;
	border: 0.906em solid transparent;
	border-left-color: #bbc9ad;
	border-right: 0;
	border-bottom: 0;
	margin-top: -0.453em;
	margin-right: -0.906em;
}

.speech-bubble-left {
	position: relative;
	background: #9ab9e2;
	border-radius: .4em;
}

.speech-bubble-left:before {
	content: '';
	position: absolute;
	left: 0;
	top: 50%;
	width: 0;
	height: 0;
	border: 0.906em solid transparent;
	border-right-color: #9ab9e2;
	border-left: 0;
	border-bottom: 0;
	margin-top: -0.453em;
	margin-left: -0.906em;
}
</style>